import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import useStores from 'utils/useStores';

import BaseGroupComponent from 'components/groups/BaseGroup';
import Checkbox from 'shared/Checkbox';

import Text from 'shared/TextWithSub/components/Text';
import TextWithSub from 'shared/TextWithSub/components/TextWithSub';
import Input from 'components/elements/Input';
import { VARIANT } from 'constants/inputTypes';

import placeholder from 'utils/placeholder';
import AvailableMillingOutput from 'availableCoffee/models/AvailableMillingOutput';
import InputColumn from './InputColumn';
import ItemColumn from './ItemColumn';

export const VarietyCol = styled.td`
  min-width: 12em;
  max-width: 12em;
`;

export const WeightCol = styled.td`
  min-width: 12em;
  max-width: 12em;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  input[type='text'] {
    width: 5em;
  }
`;

interface CoffeeRowProps {
  item: AvailableMillingOutput;
}

const MillingOutputRow = ({ item }: CoffeeRowProps) => {
  const { availableCoffeeStore } = useStores();
  const [realSize, setLotSize] = React.useState(0);

  useEffect(() => {
    setLotSize(item.attributes.available_weight);
  }, [item.attributes.available_weight]);

  return (
    <tr>
      <ItemColumn className='align-left'>
        <TextWithSub
          text={item.attributes.local_identifier}
          textClass='item--id'
          sub={item.attributes.warehouse}
        />
      </ItemColumn>

      <td>
        <TextWithSub
          text={placeholder(item.attributes.certificate)}
          sub={placeholder(item.attributes.ico_identifier)}
        />
      </td>

      <WeightCol className='align-right'>
        <Text
          text={`${item.attributes.available_weight} kg / ${item.attributes.total_weight} kg`}
        />
      </WeightCol>

      <InputColumn className='align-center'>
        <InputWrapper>
          <BaseGroupComponent append='kg' inline={true}>
            <Input
              variant={VARIANT.DECIMAL}
              condensed={true}
              value={item.quantity}
              readOnly={!item.selected || !availableCoffeeStore.withTable}
              step={0.001}
              min={0}
              max={item.attributes.available_weight}
              validator={(e) =>
                parseFloat(e.currentTarget.value) <=
                Number(item.attributes.available_weight) + 1e-6
              }
              onChange={(e) => item.setQuantity(e.currentTarget.value)}
              onBlur={() => item.formatQuantity()}
            />
          </BaseGroupComponent>
          {availableCoffeeStore.withTable && (
            <Checkbox
              checked={item.selected}
              disabled={!realSize}
              onChange={() => availableCoffeeStore.toggleItemSelection(item)}
            />
          )}
        </InputWrapper>
      </InputColumn>
    </tr>
  );
};

export default observer(MillingOutputRow);
